import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { AutomationsLibraryModule } from '@tokeet-frontend/automations'
import { TemplatesSharedModule } from '@tv3/containers/templates/templates-shared.module'
import { BookingAutomationWizardComponent } from './booking/booking-automation-wizard.component'
import { CardAutomationWizardComponent } from './card/card-automation-wizard.component'
import { ChargeAutomationWizardComponent } from './charge/charge-automation-wizard.component'
import { ExpenseAutomationWizardComponent } from './expense/expense-automation-wizard.component'
import { ExtraAutomationWizardComponent } from './extra/extra-automation-wizard.component'
import { IncidentAutomationWizardComponent } from './incident/incident-automation-wizard.component'
import { InvoiceAutomationWizardComponent } from './invoice/invoice-automation-wizard.component'
import { LockAutomationWizardComponent } from './lock/lock-automation-wizard.component'
import { ReviewAutomationWizardComponent } from './review/review-automation-wizard.component'
import { TaskAutomationWizardComponent } from './task/task-automation-wizard.component'
import { AutomationsWizardDialogComponent } from './automations-wizard-dialog.component'
import { RateAutomationWizardComponent } from './rate/rate-automation-wizard.component'
import { MessageAutomationWizardComponent } from './message/message-automation-wizard.component'
import { AutomationTypeSelectComponent } from './automation-type-select/automation-type-select.component'
import { AutomationWizardLeftComponent } from './automation-wizard-left/automation-wizard-left.component'
import { AutomationChannelRentalSelectComponent } from './automation-channel-rental-select/automation-channel-rental-select.component'
import { DoActionAutomationComponent } from './short-automations/do-action/do-action-automation.component'
import { NewTaskAutomationComponent } from './short-automations/new-task/new-task-automation.component'
import { NotifyUsersAutomationComponent } from './short-automations/notify-users/notify-users-automation.component'
import { NotifyGuestAutomationComponent } from './short-automations/notify-guest/notify-guest-automation.component'
import { RatesSharedModule } from '@tv3/containers/rates/rates-shared.module'
import { AutomationsSharedModule } from '@tv3/containers/automations/automations-shared.module'
import { NewExpenseAutomationComponent } from '@tv3/containers/automations/automations-wizard/short-automations/new-expense/new-expense-automation.component'
import { NewIncidentAutomationComponent } from '@tv3/containers/automations/automations-wizard/short-automations/new-incident/new-incident-automation.component'
import { NotifyHandlerAutomationComponent } from '@tv3/containers/automations/automations-wizard/short-automations/notify-handler/notify-handler-automation.component'
import { NotifyUsersLockAutomationComponent } from '@tv3/containers/automations/automations-wizard/short-automations/notify-users-lock/notify-users-lock-automation.component'
import { ExpenseStoreModule } from '@tokeet-frontend/tv3-platform'
import { AISettingsStoreModule } from '@tv3/containers/ai-responder/store/ai-settings.module'
import { NewReviewAutomationComponent } from '@tv3/containers/automations/automations-wizard/short-automations/new-review/new-review-automation.component'
import { ReviewAutomationsModule } from '@tv3/containers/automations/review/review-automations.module'
import { AutomationsWizardDialogService } from '@tv3/containers/automations/automations-wizard/automations-wizard-dialog.service'
import { AutopilotAutomationGroupItemDirective } from '@tv3/containers/automations/automations-wizard/short-automations/autopilot-automations-group/autopilot-automation-group-item.directive'
import { AutopilotAutomationInfoComponent } from '@tv3/containers/automations/automations-wizard/short-automations/autopilot-automation-info/autopilot-automation-info.component'
import { AutopilotAutomationsGroupComponent } from '@tv3/containers/automations/automations-wizard/short-automations/autopilot-automations-group/autopilot-automations-group.component'
import { NotifyAutomationDelayedComponent } from '@tv3/containers/automations/automations-wizard/short-automations/notify-automation-delayed/notify-automation-delayed.component'
import { InventoryAutomationWizardComponent } from '@tv3/containers/automations/automations-wizard/inventory/inventory-automation-wizard.component'
import { NewDocumentAutomationComponent } from '@tv3/containers/automations/automations-wizard/short-automations/new-document/new-document-automation.component'
import { DocumentAutomationsModule } from '@tv3/containers/documents/automations/document-automations.module'
import { AutomationDocumentFormDialogComponent } from '@tv3/containers/automations/automations-wizard/short-automations/new-document/dialog/automation-document-form-dialog.component'
import { AutomationDocumentFormDialogService } from '@tv3/containers/automations/automations-wizard/short-automations/new-document/dialog/automation-document-form-dialog.service'
import { DocumentAutomationWizardComponent } from '@tv3/containers/automations/automations-wizard/document/document-automation-wizard.component'
import { DocumentNotificationsPrefListComponent } from './document/list/document-notifications-pref-list.component'
import { DocumentNotificationsPrefTableComponent } from './document/table/document-notifications-pref-table.component'
import { DocumentsPrefSharedModule } from '@tv3/containers/documents/preferences/documents-pref-shared.module'
import { AutomationTimeOptionsComponent } from './automation-time-options/automation-time-options.component'
import { GuestAutomationWizardComponent } from './guest/guest-automation-wizard.component'
import { AutoSendReviewAutomationComponent } from './short-automations/new-review/auto-send-review-automation.component'
import { SecurityDepositAutomationWizardComponent } from './security-deposit/security-deposit-automation-wizard.component'

const components = [
  //
  AutomationTypeSelectComponent,
  AutomationChannelRentalSelectComponent,
  AutomationTimeOptionsComponent,
  AutomationWizardLeftComponent,
  AutopilotAutomationInfoComponent,
  //
  NotifyAutomationDelayedComponent,
  DoActionAutomationComponent,
  NewTaskAutomationComponent,
  NewExpenseAutomationComponent,
  NewIncidentAutomationComponent,
  NewReviewAutomationComponent,
  AutoSendReviewAutomationComponent,
  AutomationDocumentFormDialogComponent,
  NewDocumentAutomationComponent,
  NotifyUsersAutomationComponent,
  NotifyGuestAutomationComponent,
  NotifyHandlerAutomationComponent,
  NotifyUsersLockAutomationComponent,

  //
  AutopilotAutomationsGroupComponent,
  AutopilotAutomationGroupItemDirective,

  //
  BookingAutomationWizardComponent,
  CardAutomationWizardComponent,
  ChargeAutomationWizardComponent,
  ExpenseAutomationWizardComponent,
  ExtraAutomationWizardComponent,
  GuestAutomationWizardComponent,
  IncidentAutomationWizardComponent,
  InvoiceAutomationWizardComponent,
  LockAutomationWizardComponent,
  ReviewAutomationWizardComponent,
  TaskAutomationWizardComponent,
  SecurityDepositAutomationWizardComponent,
  RateAutomationWizardComponent,
  MessageAutomationWizardComponent,
  DocumentNotificationsPrefTableComponent,
  DocumentNotificationsPrefListComponent,
  DocumentAutomationWizardComponent,
  AutomationsWizardDialogComponent,
  InventoryAutomationWizardComponent,
]

const modules = [
  //
  SharedModule,
  AutomationsSharedModule,
  AutomationsLibraryModule,
  TemplatesSharedModule,
  RatesSharedModule,
  ExpenseStoreModule,
  AISettingsStoreModule,
  ReviewAutomationsModule,
  DocumentAutomationsModule,
  DocumentsPrefSharedModule,
]

const services = [AutomationDocumentFormDialogService, AutomationsWizardDialogService]

@NgModule({
  declarations: [...components, AutomationWizardLeftComponent],
  imports: [CommonModule, ...modules],
  exports: [...components, ...modules],
  providers: [...services],
})
export class AutomationsWizardModule {}
